import ProductFilterList from './ProductFilterList'

export default ProductFilterList
